export default __webpack_public_path__ + "static/media/img_cloud1.43268abd.png";